import PbAjax from "up-pbajax";
import Loading from 'c-up-loading';
import publicPB from '@js/base/public.pb';
import notification from 'c-notification';
import lang from '@js/lang';
import Cache from 'c-cache';
import global from '@js/base/global';
import { encryptBuf } from "up-crypted";
import { getPbFun } from '@js/pb_map';
import dataEncry from '@js/pb_map/protos_file/DataEncry.pb';

const cache = new Cache({
    prefix: 'pcuplive'
});

const pbAjax = new PbAjax();


/**
 * pb请求数据
 * @param {Object} config pbajax 配置
 * @param {Object} params 参数
 * @param {Object} pbObj 解析加密参数的pd对象
 */
const baseAjax =({ service, api, header, params, loading=true }) => {
    loading && Loading.show()
    const config = {
        service,
        api,
        header: Object.assign({
            userToken: global.getUser().userToken,
            UserAgent: global.getGlobalUA()
        }, header)
    }
    return new Promise((resolve, reject) => {
        pbAjax.do(
            config,
            params,
            (res) => {
                loading && Loading.hide();
                const dataWrap = publicPB.Result.decode(res);
                resolve(dataWrap);
            },
            () => {
                loading && Loading.hide();
                notification.simple(lang.template("网络连接有误, 请稍后再试"));
                reject( { code: -1, data: null });
            },
            () => {
                loading && Loading.hide();
                notification.simple(lang.template("网络连接有误, 请稍后再试"));
                reject( { code: -2, data: null });
            }
        );
    })

}




// 系统配置
export const sysPreload = async () => {
    const encryed = cache.getCache('systemEn');
    if(typeof encryed == 'boolean') { return Promise.resolve(encryed) }
    const api = "/system/preload/new";
    const { decode, Request } = getPbFun(api);
    const time = Date.now();
    const _params = { lastTime: time};
    const params = new Request(_params);
    console.log(params, '/system/preload/new, 请求参数', _params)
    return baseAjax({
        service: "service",
        api,
        params,
        loading: false
    }).then(res => {
        console.log(res, '/system/preload/new, 解析后数据')
        const { code, data } = res;
        if(code == 1) {
            const _data = data && data.value ? decode(data.value) : data;
            const apiEncryFlag = Boolean(_data.apiEncryFlag);
            cache.setCache('systemEn', apiEncryFlag, time + 5 * 60 * 60 * 1000);
            return apiEncryFlag;
        } else {
            return false;
        }
    }).catch(e => {
        return false;
    })
}

/*
*
* @params needLoading  是否loading
* @params header   请求头
* @params api    请求路径
* @params service 服务
* @params params  请求参数
* @params blendEn   是否是上行混合加密
* @params defailed  是否解密失败
*/

 const request = async ({service, api, params = {}, header = {}, needLoading=true, blendEn=false, defailed = false }) => {
    params = Array.isArray(params) ? [ ...params ] : { ...params };
    const { decode, Request } = getPbFun(api);
    let _params;
    console.log(`%c 请求参数 ${api}`, 'color:blue', params);
    // 加密
    if(blendEn) {
        const isEmParam = !Object.keys(params).length;
        let dataEn, reqParams = { dataModel: 2 };
        if(!isEmParam) {
            let encrypt = false;
            try {
                if(!defailed) {
                    encrypt = await sysPreload();
                }
            } catch(e) {
                console.log(e, '获取加密状态失败')
            }
            _params = new Request(params).toBuffer();
            dataEn = encryptBuf(_params, encrypt);
            reqParams = { encryData: dataEn, dataModel: 0 };
        }
        _params = new dataEncry.Data.Encry.Request(reqParams);
    } else {
        _params = new Request(_params);
    }
    return baseAjax({
        service,
        api,
        header,
        params: _params,
        loading: needLoading,
    }).then(res => {
        const { code, data } = res;
        if (code == 1) {
            let { value } = data || {};
            let decodeData = decode && value ? decode(value) : res;
            if(decode) { console.log(`%c 解析后的数据 ${api}`, 'color:red', res); }
            return { data: decodeData, code };
        } else {
            if (code == 1179706) {
                // 解密失败
                return request({
                    service,
                    api,
                    params,
                    header,
                    needLoading,
                    blendEn,
                    defailed: true
                })
            }
            return { ...data, code };
        }
    });
}
export default request;


// WEBPACK FOOTER //
// ./js/service/requestEn.js